import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ReactTemplateSymbol, ESMLoaderSymbol, PromiseCacheSymbol, ImportMapSymbol } from './symbols'
import { ReactTemplateFactory } from './reactTemplateFactory'
import { ESMLoaderFactory } from './esmLoaderFactory'
import { PromiseCache } from './promiseCache'
import { ImportMapFactory } from './importMapFactory'

export const site: ContainerModuleLoader = (bind) => {
	bind(ReactTemplateSymbol).to(ReactTemplateFactory)
	bind(PromiseCacheSymbol).to(PromiseCache)
	bind(ImportMapSymbol).to(ImportMapFactory)
	bind(ESMLoaderSymbol).to(ESMLoaderFactory)
}

// Export symbols and types for use by other features
export { ESMLoaderSymbol, ImportMapSymbol } from './symbols'
export type { ImportMap } from './types'
